module.exports = __webpack_public_path__ + "static/media/info.36183c8b.svg";